import { render, staticRenderFns } from "./PointsGoodsModal.vue?vue&type=template&id=5fe65572&scoped=true&"
import script from "@/scripts/Points/components/PointsGoodsModal.js?vue&type=script&lang=js&"
export * from "@/scripts/Points/components/PointsGoodsModal.js?vue&type=script&lang=js&"
import style0 from "./PointsGoodsModal.vue?vue&type=style&index=0&id=5fe65572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe65572",
  null
  
)

export default component.exports